import React from 'react';
import { PanelLayout } from '../../layout/Panel/Panel';
import IconComponent from '../../shared/IconComponents/IconComponent';
import { TColorRole } from '../../../types/types';

interface IChatIconProps {
    iconName: string;
    background?: TColorRole;
}

export const ChatIcon: React.FC<IChatIconProps> = ({ iconName, background = 'accent-blue' }) => {
    return (
        <div style={{ width: '28px', height: '28px' }}>
            <PanelLayout color={background} borderIntensity={0} hasShadow={false}>
                <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <IconComponent size={2.6} iconName={iconName} />
                </div>
            </PanelLayout>
        </div>
    );
};
